exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".presentation > .row {\n  padding-bottom: 5px; }\n\n.presentation > .row:nth-child(odd) {\n  background-color: rgba(93, 156, 236, 0.34); }\n\n.presentation b {\n  word-break: break-word; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/shared/famille/info/info.component.scss
// module id = ../../../../../src/app/shared/famille/info/info.component.scss
// module chunks = main